let scrollInstance: any = null;

export const initSmoothScroll = () => {
  if (typeof window !== 'undefined' && !scrollInstance) {
    // Dynamically import smooth-scroll to avoid SSR issues
    import('smooth-scroll').then((SmoothScroll) => {
      const SmoothScrollClass = SmoothScroll.default || SmoothScroll;
      scrollInstance = new SmoothScrollClass('a[href*="#"]', {
        speed: 500,
        speedAsDuration: true,
        easing: 'easeInOutCubic',
      });
    }).catch((err) => {
      console.warn('SmoothScroll not available:', err);
    });
  }
  return scrollInstance;
};

export const destroySmoothScroll = () => {
  if (scrollInstance && typeof scrollInstance.destroy === 'function') {
    scrollInstance.destroy();
    scrollInstance = null;
  }
};

